module.exports = __webpack_public_path__ + "static/media/PLANTA.45fde9df.jpg";